module.exports = __webpack_public_path__ + "img/footer-text_1400.7f717700.png";